import { Button, Grid, Typography } from "@mui/material"
import { ModalComponent } from "../../../../../../../components/modal"
import animationCongratulation from "../../../../../../../assets/animation/congratulations.json"
import Lottie from "react-lottie";
import { useNavigate } from "react-router-dom";

interface Props {
    open: boolean,
    onClose: () => void
}

const referAndWinOptions = {
    loop: true,
    autoplay: true,
    animationData: animationCongratulation,
    rendererSettings: {
        preserveAspectRatio: 'xMidYMid slice',
    },
};

export const ModalCongratulationsWithdraw = ({
    onClose,
    open
}: Props) => {
    const navigate = useNavigate()

    return (
        <ModalComponent
            open={open}
            withoutHeader
        >
            <Grid
                width={"100%"}
                display={"flex"}
                direction={"column"}
                gap={"1.2rem"}
                alignItems={"center"}
            >

                <div style={{ width: "15.7rem", height: 'auto', margin: "-4rem 0px -2rem 0px" }}>
                    <Lottie options={referAndWinOptions} />
                </div>

                <Typography fontWeight={600} fontSize={"2.4rem"}>Parabéns</Typography>

                <Typography fontSize={"1.5rem"} textAlign={"center"}>
                    Saque efetuado com sucesso.
                    <br />
                    Verifique sua conta bancária.
                </Typography>

                <Button
                    variant="outlined"
                    sx={{
                        width: "100%",
                        maxWidth: "17.5rem",
                        height: "4rem",
                        borderColor: "rgba(121, 116, 126, 1)",
                        mb: "-1.5rem"
                    }}
                    onClick={() => {
                        onClose()
                    }}
                >Fechar</Button>
            </Grid>
        </ModalComponent>
    )
}